export default "__VITE_ASSET__CNxD1k_d__"